import { render, staticRenderFns } from "./CustomerAsset.vue?vue&type=template&id=820a7a06"
import script from "./CustomerAsset.vue?vue&type=script&lang=js"
export * from "./CustomerAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports